import { render, staticRenderFns } from "./call-out.vue?vue&type=template&id=7d6b32a8&"
var script = {}
import style0 from "./call-out.vue?vue&type=style&index=0&id=7d6b32a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports